// extracted by mini-css-extract-plugin
var _1 = "PaymentModal_close__Jn2DJ";
var _2 = "PaymentModal_content__WwKhs";
var _3 = "PaymentModal_pmContainer__oUevB";
var _4 = "PaymentModal_pmSubtitle__qX5NJ";
var _5 = "PaymentModal_pmTitle__qewfh";
export { _1 as "close", _2 as "content", _3 as "pmContainer", _4 as "pmSubtitle", _5 as "pmTitle" }
